import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import PumpandCassettereplacementforpHController10mls from "../../Assets/Pump and Cassette replacement for pH Controller - 10mls.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Pump_and_Cassette_replacement_for_pH_Controller = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 26,
      name: "Pump and Cassette replacement for pH Controller - 10mls",
      price: 10584,
      image: PumpandCassettereplacementforpHController10mls,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={PumpandCassettereplacementforpHController10mls}
                  alt="Product 1"
                  className="d-block w-100"
                />
              </div>
              {/* Add more images to the carousel as needed */}
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">
              Pump and Cassette replacement for pH Controller - 10mls
            </h2>
            <p className="product-price">₹{10584}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3">
              <ul>
                <li>pH Controller compatibility only.</li>
                <li>
                  The Pump and Cassette replacement for pH Controller provides a
                  10ml/min flow rate, ensuring precise and accurate pH dosing.
                  Ideal for maintaining consistent pH levels, it is designed to
                  work seamlessly with Bluelab pH controllers.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Pump_and_Cassette_replacement_for_pH_Controller;
